/**
 * Builds the activity WebSocket URL. Supports relative API base (Vite proxy)
 * or absolute `VITE_API_BASE_URL` (production / split origin).
 */
export function buildActivityWsUrl(accessToken: string): string {
  const token = encodeURIComponent(accessToken);
  const raw = (import.meta.env.VITE_API_BASE_URL as string | undefined) || '/api/v1/';
  const base = raw.endsWith('/') ? raw.slice(0, -1) : raw;

  if (base.startsWith('http://') || base.startsWith('https://')) {
    const u = new URL(base);
    const wsProto = u.protocol === 'https:' ? 'wss:' : 'ws:';
    const path = `${u.pathname.replace(/\/$/, '')}/ws`;
    return `${wsProto}//${u.host}${path}?token=${token}`;
  }

  const wsProto = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const prefix = base.startsWith('/') ? base : `/${base}`;
  return `${wsProto}//${window.location.host}${prefix}/ws?token=${token}`;
}
